// extracted by mini-css-extract-plugin
export default {"box":"home_box__QRYBe","video":"home_video__SEOVf","video__container":"home_video__container__NiiCf","video__wrap":"home_video__wrap__mW46k"};